<template>
  <div>
    <v-row class="ma-1">
      <v-col cols="12" class="text-end">
        <h3 v-if="showDate === true">
          Your current plan will expire on
          {{ getFormattedDate(currentPlan?.expiration_date) }}
          <router-link to="/societyadmin/plan" tag="button">
            <v-btn color="secondary" dark class="ml-2">Buy now</v-btn>
          </router-link>
        </h3>
        <h3 class="mt-2" v-if="societyCode">
          Society Code: <span class="primary--text">{{ societyCode }}</span>
        </h3>
      </v-col>
    </v-row>

    <v-row class="ma-1">
      <v-col cols="6" sm="6" md="3" class="d-flex">
        <v-card class="pl-5 py-7 rounded-lg flex-grow-1 cursor-pointer" flat>
          <router-link
            to="/societyadmin/house/list"
            class="text-decoration-none"
          >
            <v-row class="black--text">
              <v-col cols="4">
                <v-icon
                  x-large
                  class="rounded-circle light-blue--text light-blue lighten-5 pa-3"
                  >mdi-home</v-icon
                >
              </v-col>
              <v-col cols="7">
                <span class="text-h4 font-weight-bold">{{ members }}</span
                ><br />
                <span class="text-body-2">Members</span>
              </v-col>
            </v-row>
          </router-link>
        </v-card>
      </v-col>
      <v-col cols="6" sm="6" md="3" class="d-flex">
        <v-card class="pl-5 py-7 rounded-lg flex-grow-1 cursor-pointer" flat>
          <router-link
            to="/societyadmin/house/requests"
            class="text-decoration-none"
          >
            <v-row class="black--text">
              <v-col cols="4">
                <v-icon
                  x-large
                  class="rounded-circle light-blue--text light-blue lighten-5 pa-3"
                  >mdi-share-outline</v-icon
                >
              </v-col>
              <v-col cols="7">
                <span class="text-h4 font-weight-bold">{{
                  memberRequests
                }}</span
                ><br />
                <span class="text-body-2">Member Request</span>
              </v-col>
            </v-row>
          </router-link>
        </v-card>
      </v-col>
      <v-col cols="6" sm="6" md="3" class="d-flex">
        <v-card
          class="pl-5 py-7 pr-0 rounded-lg flex-grow-1 cursor-pointer"
          flat
        >
          <router-link to="/societyadmin/event" class="text-decoration-none">
            <v-row class="black--text">
              <v-col cols="4">
                <v-icon
                  x-large
                  class="rounded-circle light-blue--text light-blue lighten-5 pa-3"
                  >mdi-calendar-clock</v-icon
                >
              </v-col>
              <v-col cols="7">
                <span class="text-h4 font-weight-bold">{{
                  upcomingevents
                }}</span
                ><br />
                <span class="text-body-2">Upcoming Events</span>
              </v-col>
            </v-row>
          </router-link>
        </v-card>
      </v-col>
      <v-col cols="6" sm="6" md="3" class="d-flex">
        <v-card class="pl-5 py-7 rounded-lg flex-grow-1 cursor-pointer" flat>
          <router-link to="/societyadmin/staff" class="text-decoration-none">
            <v-row class="black--text">
              <v-col cols="4">
                <v-icon
                  x-large
                  class="rounded-circle light-blue--text light-blue lighten-5 pa-3"
                  >mdi-account-switch</v-icon
                >
              </v-col>
              <v-col cols="7">
                <span class="text-h4 font-weight-bold">{{ staffs }}</span
                ><br />
                <span class="text-body-2">Staff</span>
              </v-col>
            </v-row>
          </router-link>
        </v-card>
      </v-col>
      <v-col cols="6" sm="6" md="3" class="d-flex">
        <v-card class="pl-5 py-7 rounded-lg flex-grow-1 cursor-pointer" flat>
          <router-link
            to="/societyadmin/complaints"
            class="text-decoration-none"
          >
            <v-row class="black--text">
              <v-col cols="4">
                <v-icon
                  x-large
                  class="rounded-circle light-blue--text light-blue lighten-5 pa-3"
                  >mdi-help</v-icon
                >
              </v-col>
              <v-col cols="7">
                <span class="text-h4 font-weight-bold">{{
                  openComplaints
                }}</span
                ><br />
                <span class="text-body-2">Open Complaints</span>
              </v-col>
            </v-row>
          </router-link>
        </v-card>
      </v-col>
      <v-col cols="6" sm="6" md="3" class="d-flex">
        <v-card class="pl-5 py-7 rounded-lg flex-grow-1 cursor-pointer" flat>
          <router-link
            to="/societyadmin/securityguard"
            class="text-decoration-none"
          >
            <v-row class="black--text">
              <v-col cols="4">
                <v-icon
                  x-large
                  class="rounded-circle light-blue--text light-blue lighten-5 pa-3"
                  >mdi-security</v-icon
                >
              </v-col>
              <v-col cols="7">
                <span class="text-h4 font-weight-bold">{{
                  securityguards
                }}</span
                ><br />
                <span class="text-body-2">Security Guards</span>
              </v-col>
            </v-row>
          </router-link>
        </v-card>
      </v-col>
      <v-col cols="6" sm="6" md="3" class="d-flex">
        <v-card class="pl-5 py-7 rounded-lg flex-grow-1 cursor-pointer" flat>
          <router-link
            to="/societyadmin/committemember"
            class="text-decoration-none"
          >
            <v-row class="black--text">
              <v-col cols="4">
                <v-icon
                  x-large
                  class="rounded-circle light-blue--text light-blue lighten-5 pa-3"
                  >mdi-account-multiple-outline</v-icon
                >
              </v-col>
              <v-col cols="7">
                <span class="text-h4 font-weight-bold">{{
                  committeeMembers
                }}</span
                ><br />
                <span
                  class="text-body-2 d-inline-block text-truncate"
                  :style="{ maxWidth: '100%' }"
                  >Committee Members</span
                >
              </v-col>
            </v-row>
          </router-link>
        </v-card>
      </v-col>
      <v-col cols="6" sm="6" md="3" class="d-flex">
        <v-card class="pl-5 py-7 rounded-lg flex-grow-1 cursor-pointer" flat>
          <router-link to="/societyadmin/notice" class="text-decoration-none">
            <v-row class="black--text">
              <v-col cols="4">
                <v-icon
                  x-large
                  class="rounded-circle light-blue--text light-blue lighten-5 pa-3"
                  >mdi-clipboard</v-icon
                >
              </v-col>
              <v-col cols="7">
                <span class="text-h4 font-weight-bold">{{ notices }}</span
                ><br />
                <span class="text-body-2">Notices</span>
              </v-col>
            </v-row>
          </router-link>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4">
        <v-card class="rounded-lg ml-4" flat>
          <v-card-title :style="{ textAlign: 'center' }">
            Bills
            <span class="text-body-2 grey--text ml-2">(Current Month)</span>
          </v-card-title>
          <v-card-text>
            <pie-chart
              :data="chartData"
              :options="chartOptions"
              ref="chart"
              v-if="loaded"
            ></pie-chart>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PieChart from "./PieChart.js";

export default {
  components: {
    PieChart,
  },
  data() {
    return {
      openComplaints: 0,
      staffs: 0,
      upcomingevents: 0,
      securityguards: 0,
      notices: 0,
      committeeMembers: 0,
      memberRequests: 0,
      members: 0,
      societyCode: "",
      unpaid_bills: 0,
      paid_bills: 0,
      chartOptions: {
        hoverBorderWidth: 20,
      },
      chartData: {
        hoverBackgroundColor: "red",
        hoverBorderWidth: 10,
        labels: ["Paid", "Unpaid"],
        datasets: [
          {
            label: "Bill",
            backgroundColor: ["#00FFFF", "#FF5733"],
            data: [0, 0],
          },
        ],
      },
      loaded: false,
      currentPlan: [],
      showDate: [],
    };
  },
  methods: {
    getCounts() {
      this.$axios.get("societyadmin/dashboard").then((response) => {
        let data = response.data;

        this.openComplaints = data.openComplaints;
        this.staffs = data.staffs;
        this.upcomingevents = data.upcomingevents;
        this.securityguards = data.securityguards;
        this.notices = data.notices;
        this.committeeMembers = data.committeeMembers;
        this.memberRequests = data.memberRequests;
        this.members = data.members;
        this.unpaid_bills = data.unpaid_bills;
        this.paid_bills = data.paid_bills;
        this.societyCode = data.society_code;

        let t = [];
        t.push(this.paid_bills);
        t.push(this.unpaid_bills);

        this.chartData.datasets[0].data = t;
        this.loaded = true;
      });
    },
    getUserPlan() {
      let _self = this;

      _self.$axios.get("societyadmin/user-plan").then((response) => {
        let data = response.data;

        if (data.status) {
          _self.currentPlan = data.current;

          _self.showDate = data.showDate;
        } else {
          _self.setAlert({
            showAlert: true,
            variant: "red accent-3",
            timeout: "2000",
            message: data.message,
          });
        }
      });
    },
    getFormattedDate(date) {
      const parsedDate = new Date(date);
      const year = parsedDate.getFullYear();
      const month = (parsedDate.getMonth() + 1).toString().padStart(2, "0");
      const day = parsedDate.getDate().toString().padStart(2, "0");
      return `${day}-${month}-${year}`;
    },
  },
  mounted() {
    this.getCounts();
    this.getUserPlan();
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
